export var BetStatus;
(function (BetStatus) {
    BetStatus[BetStatus["Default"] = 0] = "Default";
    BetStatus[BetStatus["Waiting"] = 1] = "Waiting";
    BetStatus[BetStatus["Rejected"] = 2] = "Rejected";
    BetStatus[BetStatus["Accepted"] = 3] = "Accepted";
    BetStatus[BetStatus["NewOffer"] = 4] = "NewOffer";
})(BetStatus || (BetStatus = {}));
//# sourceMappingURL=BetStatus.js.map